import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Row, TextLabel } from '../atoms';
import { InfoPopover } from '../organisms';
import { help } from './copy';
const _getHeader = (columnName, toolTipContent) => {
    return (_jsxs(Row.L, { children: [_jsx(TextLabel, { mr: "1", color: "tertiary", em: true, children: columnName }), _jsx(InfoPopover, { content: toolTipContent })] }));
};
export const FUND_TABLE_HEADER_CELL_TEMPLATES = {
    TOTAL_NET_INVESTED: () => _getHeader(`Total net invested`, help.totalNetInvested),
    NO_OF_SHARES: () => _getHeader(`# of shares`, help.nbOfShares),
    TOTAL_VALUE: () => _getHeader(`Total value`, help.totalValue),
    ALLOCATION: () => _getHeader(`Allocation`, help.allocation),
    PAST_MONTH_PERF: () => _getHeader(`Past month perf.`, help.pastMonthPerf),
    YTD: () => _getHeader(`YTD`, help.ytd),
    ITD: () => _getHeader(`ITD`, help.itd),
    VALUE_USD: () => _getHeader(`Value`, help.valueUsd),
};
